<app-header></app-header>
<app-landing-hero-banner></app-landing-hero-banner>
<app-landing-feature></app-landing-feature>
<app-landing-pricing></app-landing-pricing>
<app-landing-testimonials></app-landing-testimonials>
<app-footer></app-footer>
